import React, {Fragment, useState} from 'react';
import cn from 'classnames';
import Tooltip from '@dealroadshow/uikit/core/components/Tooltip';
import CountryFlag from '@dealroadshow/uikit/core/components/CountryFlag';
import IconPlus from '@dealroadshow/uikit/core/components/Icon/IconPlus';
import IconMinus from '@dealroadshow/uikit/core/components/Icon/IconMinus';
import staticTemplateStyles from '@/finsight/ui/components/static/StaticTemplate/staticTemplate.scss';
import styles from './role.scss';

interface IDescription {
  name?: string,
  isList?: boolean,
  paragraphs: React.ReactNode[],
}

export interface IRoleProps {
  name: string,
  department: string,
  locations: string[],
  description: IDescription[]
}

const Role = (props: IRoleProps) =>  {
  const [isExpanded, setIsExpanded] = useState<boolean>(false)

  const toggleIsExpanded = () => setIsExpanded((prev) => !prev);

  const getFlagByOffice = (officeName: string) => {
    switch (officeName) {
      case 'New York, NY':
      case 'Miami, FL':
        return 'us';
      case 'London, UK':
        return 'gb';
      case 'Kyiv, Ukraine':
        return 'ua';
      case 'Hong Kong':
        return 'hk';
      default:
        return 'us';
    }
  };

  const renderParagraphs = (item, i) => (
    <p key={ i }>
      { item }
    </p>
  );

  const renderList = (item, i) => (
    <li key={ i }>
      { item }
    </li>
  );

  const renderDescription = (item, i) => (
    <Fragment key={ i }>
      { item.name && (
        <div>
          <b><p>{ item.name }</p></b>
        </div>
      ) }
      { item.isList
        ? (
          <ul className={ staticTemplateStyles.bulletList }>
            { item.paragraphs.map(renderList) }
          </ul>
        )
        : item.paragraphs.map(renderParagraphs) }
    </Fragment>
  );

  const renderFlag = (flag, i) => (
    <div
      key={ i }
      className={ styles.flag }
    >
      <Tooltip
        key={ i }
        content={ flag }
      >
        <CountryFlag
          className={ styles.flagIcon }
          countryCode={ getFlagByOffice(flag) }
        />
      </Tooltip>
    </div>
  );

  return (
    <div
      data-test={ props.name }
      className={ cn(styles.panel, { [styles.isPanelExpanded]: isExpanded }) }
    >
      <div
        className={ styles.panelHeader }
        onClick={ toggleIsExpanded }
      >
        <div className={ cn(styles.stripe, { [styles.isConstant]: isExpanded }) } />
        <div className={ styles.contentCell }>
          <div className={ styles.roleName }>
            { props.name }
          </div>
          <div className={ styles.contentCellRightSection }>
            <div className={ styles.department }>
              { props.department }
            </div>
            <div className={ styles.locations }>
              { props.locations.map(renderFlag) }
            </div>
          </div>
        </div>
        <div className={ styles.expandIconCell }>
          <div className={ styles.expandIcon }>
            { isExpanded ? <IconMinus /> : <IconPlus /> }
          </div>
        </div>
      </div>
      <div className={ cn(styles.description, { [styles.isVisible]: isExpanded }) }>
        { props.description && props.description.map(renderDescription) }
      </div>
    </div>
  );
}

export default Role;
